const StoreroomComponent = () => import('@/views/WareHouse/Storeroom/StoreroomView')

export default [
    {
        path:'/StoreroomIndex',
        name:'StoreroomComponent',
        component:StoreroomComponent
    }
]